export const STAGE_COLORS: Record<string, { bg: string; text: string }> = {
  draft: { bg: "bg-yellow-100", text: "text-yellow-800" },
  pending_approval: { bg: "bg-orange-100", text: "text-orange-800" },
  approved: { bg: "bg-green-100", text: "text-green-800" },
  legacy_used: { bg: "bg-purple-100", text: "text-purple-800" },
  archived: { bg: "bg-blue-100", text: "text-blue-800" },
  discarded: { bg: "bg-gray-100", text: "text-gray-800" },
};

export const STAGE_LABELS: Record<string, string> = {
  draft: "Draft",
  pending_approval: "Pending",
  approved: "Approved",
  legacy_used: "Legacy",
  archived: "Archived",
  discarded: "Discarded",
};

export function getStageConfig(stage: string | undefined) {
  const stageKey = stage || "draft";
  return {
    colors: STAGE_COLORS[stageKey] || STAGE_COLORS.draft,
    label: STAGE_LABELS[stageKey] || stageKey,
  };
}
